// extracted by mini-css-extract-plugin
module.exports = {"class_svg":"herkunft_class_svg__N3IH5","class":"herkunft_class__oy55k"};